import * as ng from 'angular';
import { ComponentRegistration } from '../../../core';
import { IPasswordStrengthService } from '../services/password-strength';
let template = require('./password.html');

class PasswordComponent extends ComponentRegistration {

    constructor() {
        super('password', {
            controller: PasswordController,
            templateUrl: template,
            controllerAs: 'password',
            bindings: {
                minStrengthRating: "@",
                rating: '@',
                value: '=',
                confirm: '=',
                form: "&"
            }
        });
    }
}

interface IPasswordController {
    validate(): void;
    onChange(): void;
    calculateStrength(): void;
    getStrengthDescriptor(s): any;
}

interface IPasswordFormController extends ng.IFormController {
    password: ng.IFormController;
    confirm: ng.IFormController;
}

class PasswordController implements IPasswordController {
    private static $inject: Array<string> = ['PasswordStrength'];

    //private fields
    private themes = ['error', 'warning', 'success'];
    private strengthNames = ["Weak", "Good", "Strong"];
    private minStrength: number = 20;
    private strengthName: string;
    private theme: string;
    private hostForm: IPasswordFormController;

    //bindings
    private minStrengthRating: string;
    private rating: number;
    private value: string;
    private confirm: string;
    private form: Function;

    constructor(private PasswordStrength: IPasswordStrengthService) {

    }

    public $onInit(): void {
        this.theme = this.themes[0];
        this.rating = 0;
        this.confirm = '';
        this.strengthName = this.strengthNames[0];
        this.minStrength = parseInt(this.minStrengthRating) || this.minStrength;
        this.hostForm = this.form();

        console.log('SecurityQuestionCardController activated');
    }

    public validate(): void {
        //use the ng-message name as the key for the set validity function
        //boolean expression that describes valid.
        //TODO: verify usage of $setValidity
        (this.hostForm.password as any).$setValidity('strength', (this.minStrength <= this.rating));
        (this.hostForm.confirm as any).$setValidity("match", this.value === this.confirm);
    }

    public onChange(): void {
        this.calculateStrength();
        this.validate();
    }

    public calculateStrength(): void {
        this.rating = this.PasswordStrength.measureStrength(this.value);
        var descriptor = this.getStrengthDescriptor(this.rating);
        this.theme = descriptor.theme;
        this.strengthName = descriptor.strenghtName;
    }

    public getStrengthDescriptor(s): any {
        var idx = 0;
        if (s <= 20) { idx = 0; }
        else if (s <= 50) { idx = 1; }
        else { idx = 2; }

        return {
            theme: this.themes[idx],
            strenghtName: this.strengthNames[idx],
        };
    }

}

let pwdComponent = new PasswordComponent();
export default pwdComponent;
export { pwdComponent as PasswordComponent, IPasswordController, PasswordController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/security/user-controls/password.ts